import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavBarComponent } from './navigation/nav-bar/nav-bar.component';
import { AppContentLoaderService } from '@design-system/loaders/app-content-loader.service';
import { ContainedLoaderComponent } from '@design-system/loaders/contained-loader/contained-loader.component';

@UntilDestroy()
@Component({
  selector: 'app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NavBarComponent,
    ContainedLoaderComponent
  ]
})
export class AppLayoutComponent {
  constructor(readonly appContentLoader: AppContentLoaderService) {}
}
